<template>
    <VerificationContent :indentation-level="0">
        <VerificationGrid
            class="text-sm"
            :grid-cols="4"
            :indentation-level="0"
        >
            <CheckTextualResult
                label="File:"
                :value="{
                    state: CheckResultState.NotApplicable,
                    text: fileInformation.file,
                    stateText: '',
                    infoList: [],
                }"
            />
            <CheckTextualResult
                label="Email:"
                :value="
                    makeCheckResult({
                        state: CheckResultState.NotApplicable,
                        text: fileInformation.email,
                    })
                "
            />
            <CheckTextualResult
                label="Phone:"
                :value="
                    makeCheckResult({
                        state: CheckResultState.NotApplicable,
                        text: fileInformation.phone,
                    })
                "
            />
            <CheckTextualResult
                label="Date:"
                :value="
                    makeCheckResult({
                        state: CheckResultState.NotApplicable,
                        text: fileInformation.date,
                    })
                "
            />
            <hr class="col-span-full h-1 w-full border-b-ds-primary-300" />
            <CheckTextualResult
                label="Location:"
                :value="
                    makeCheckResult({
                        state: CheckResultState.NotApplicable,
                        text: fileInformation.location || 'Unknown',
                    })
                "
            />
            <CheckTextualResult
                label="IP:"
                :value="
                    makeCheckResult({
                        state: CheckResultState.NotApplicable,
                        text: fileInformation.ip || 'Unknown',
                    })
                "
            />
            <CheckTextualResult
                label="Authentication:"
                :value="
                    makeCheckResult({
                        state: CheckResultState.NotApplicable,
                        text: fileInformation.authentication,
                    })
                "
            />
            <div class="flex flex-col text-xs">
                <div
                    v-if="fileInformation?.property_address"
                    class="font-normal"
                >
                    <div class="inline pr-1">Property Address</div>
                    <div class="break-words font-semibold">
                        {{ fileInformation.property_address }}
                    </div>
                </div>
            </div>
        </VerificationGrid>
    </VerificationContent>
</template>

<script lang="ts" setup>
import type { FileInformation } from '@/api/interfaces/bank-account-verification.api';
import { CheckResultState } from '@/api/interfaces/identity-verification-report.api';
import { makeCheckResult } from '@/components/Components/BankAccountVerification/report-check-result-mapping';
import CheckTextualResult from '../../IdentityVerificationReport/common/CheckTextualResult.vue';
import VerificationContent from '../../IdentityVerificationReport/common/VerificationContent.vue';
import VerificationGrid from '../../IdentityVerificationReport/common/VerificationGrid.vue';

defineProps<{ fileInformation: FileInformation }>();
</script>
